<div class="filter-header"><span>{{ 'dashboard:Filter dashboards' | i18next }}</span></div>

<div class="filter-wraper">
  <div [ngClass]="['filter-icon', 'search-icon']"><i class="fal fa-search"></i></div>
  <input type="text" [(ngModel)]="filter" class="filter"
    placeholder="{{ 'dashboard:Search for dashboards' | i18next }}" />
  <div [ngClass]="['filter-icon', 'clear-icon']"><button *ngIf="filter.length>0" (click)="filter=''"><i class="fal fa-times"></i></button>
  </div>
</div>

<mat-dialog-content>

  <div class="dashboard-box">
    <div class="title"><i class="fal fa-table"></i> {{ 'dashboard:My Dashboards' | i18next }}
      ({{(mySettings().length==mySettingsCount())?mySettingsCount():mySettings().length + '/' + mySettingsCount()}})
    </div>
    <div cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="filter.length > 0"
      class="dashboards-list thin-scroll">
      <div class="dashboards-list-box" *ngFor="let ds of mySettings()" cdkDrag
        [style.cursor]="filter.length> 0 ? 'inherit':'move'">
        <div class="drag-placeholder" *cdkDragPlaceholder></div>
        <i class="fa fa-bars"></i>
        <div class="checkbox" [class.checked]="ds.visible && visibleCount!=1" (click)="dashboardSettingChange(ds)">
          <i class="fas fa-check" [class.hidden]="!ds.visible"></i>
        </div>
        <span class="dashboards-list-name" (click)="dashboardSettingChange(ds)">
          <span>{{ds.name}}</span>
          <dashboard-access-icon [dashboard]="ds"></dashboard-access-icon>
        </span>
        <button class="icon-favorite" (click)="ds.isFavorite=!ds.isFavorite;setDirty()">
          <i class="fa-star" [class.star-selected]="ds.isFavorite" [class]="ds.isFavorite?'fas':'fal star-icon'"></i>
        </button>
        <div class="dashboard-owner-info">
          <span *ngIf="ds.isPublic" class="my-dashboards-owner-name">{{ds.ownerName}}</span><i
            *ngIf="canTransferOwnership(ds)" (click)="changeOwner(ds)" class="far fa-edit owner-icon" [matTooltip]="'dashboard:Transfer ownership' | i18next" matTooltipClass="tooltip"></i>
        </div>
      </div>
      <div *ngIf="mySettings().length == 0" class="dashboards-list-box-empty">
        <i class="fal fa-search"></i>
        <span>{{"dashboard:Sorry, We couldn't find any results." | i18next}}</span>
      </div>
    </div>
  </div>

  <div class="dashboard-box">
    <div class="title"><i class="fal fa-users"></i> {{ 'dashboard:Company Dashboards' | i18next }}
      ({{publicSettings().length==publicCount?publicCount:publicSettings().length + "/" + publicCount}})
    </div>
    <div class="dashboards-list thin-scroll">
      <div class="dashboards-list-box" *ngFor="let ds of publicSettings()">
        <div class="checkbox" [class.checked]="ds.visible && visibleCount!=1" (click)="dashboardSettingChange(ds)">
          <i class="fas fa-check" [class.hidden]="!ds.visible"></i>
        </div>
        <span class="dashboards-list-name" (click)="dashboardSettingChange(ds)">
          <span>{{ds.name}}</span>
          <dashboard-access-icon [dashboard]="ds"></dashboard-access-icon>
        </span>
        <button class="icon-favorite" (click)="ds.isFavorite=!ds.isFavorite;setDirty()">
          <i class="fa-star" [class.star-selected]="ds.isFavorite" [class]="ds.isFavorite?'fas':'fal star-icon'"></i>
        </button>
        <div class="dashboard-owner-info">
          <span *ngIf="ds.isPublic" class="dashboard-owner-name">{{ds.ownerName}}</span><i
            *ngIf="canTransferOwnership(ds)" (click)="changeOwner(ds)" class="far fa-edit owner-icon" [matTooltip]="'dashboard:Transfer ownership' | i18next" matTooltipClass="tooltip"></i>
        </div>
      </div>
      <div *ngIf="publicSettings().length==0 && filter.length==0" class="dashboards-list-box-empty">
        <i class="fal fa-users"></i>
        <span>{{'dashboard:No public dashboards available' | i18next}}</span>
      </div>
      <div *ngIf="publicSettings().length==0 && filter.length>0" class="dashboards-list-box-empty">
        <i class="fal fa-search"></i>
        <span>{{"dashboard:Sorry, We couldn't find any results." | i18next}}</span>
      </div>
    </div>
  </div>

  <div class="dashboard-box">
    <div class="title"><i class="fas fa-star star-selected"></i> {{ 'dashboard:My Favorites' | i18next }}
      ({{favoritesSettings().length==favoritesCount?favoritesCount:favoritesSettings().length + "/" + favoritesCount}})
    </div>
    <div class="dashboards-list thin-scroll">
      <div class="dashboards-list-box" *ngFor="let ds of favoritesSettings()">
        <div class="checkbox" [class.checked]="ds.visible && visibleCount!=1" (click)="dashboardSettingChange(ds)">
          <i class="fas fa-check" [class.hidden]="!ds.visible"></i>
        </div>
        <span class="dashboards-list-name" (click)="dashboardSettingChange(ds)">
          <span>{{ds.name}}</span>
          <dashboard-access-icon [dashboard]="ds"></dashboard-access-icon>
        </span>
        <button class="icon-favorite" (click)="ds.isFavorite=!ds.isFavorite;setDirty()">
          <i [ngClass]="['fa-star']" [class.star-selected]="ds.isFavorite" [class]="ds.isFavorite?'fas':'fal star-icon'"></i>
        </button>

        <div class="dashboard-owner-info">
          <span *ngIf="ds.isPublic" class="dashboard-owner-name">{{ds.ownerName}}</span> <i
            *ngIf="canTransferOwnership(ds)" (click)="changeOwner(ds)" class="far fa-edit owner-icon" [matTooltip]="'dashboard:Transfer ownership' | i18next" matTooltipClass="tooltip"></i>
        </div>
      </div>
      <div *ngIf="favoritesSettings().length==0 && filter.length==0" class="dashboards-list-box-empty">
        <i [ngClass]="['fal fa-star', 'star-icon']"></i>
        <span>{{'dashboard:No favorites dashboards available' | i18next}}</span>
      </div>
      <div *ngIf="favoritesSettings().length==0 && filter.length>0" class="dashboards-list-box-empty">
        <i class="fal fa-search"></i>
        <span>{{"dashboard:Sorry, We couldn't find any results." | i18next}}</span>
      </div>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions>
  <button matButton (click)="onCancelClick()" class="secondary-button">{{ 'Cancel' | i18next }}</button>
  <button matButton (click)="onApplyClick()" [disabled]="!isDirty" class="primary-button">{{ 'Apply Changes' |
    i18next}}</button>
</mat-dialog-actions>